import { faFlag } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import type { IndFlag } from '@api/Entities/Ind/IndFlag';
import clsx from 'clsx';

export type IndFlagButtonProps = {
  flag: IndFlag;
  selected?: boolean;
  onToggle?: (flag: string) => void;
  className?: string;
};

export const IndFlagButton = ({
  flag,
  selected = false,
  onToggle,
  className,
}: IndFlagButtonProps) => {
  const color = flag.getIndFlagged();
  const defaultClassList = ['border', 'border-' + color, 'p-1'];

  if (selected) {
    defaultClassList.push('text-white', 'bg-' + color);
  } else {
    defaultClassList.push('text-' + color);
  }

  if (!onToggle) {
    defaultClassList.push('cursor-default');
  }

  const mergedClassList = clsx(defaultClassList, className);

  return (
    <Button
      onClick={onToggle ? () => onToggle(color) : undefined}
      variant="white"
      size="sm"
      className={mergedClassList}
    >
      <FontAwesomeIcon className="d-block" icon={faFlag} />
    </Button>
  );
};
